import React from 'react'
import HowItWorksHero from '../components/How-it-work/how-it-works-hero'
import LeadTimeline from '../components/How-it-work/timeline'
import VerificationDetail from '../components/How-it-work/verification';
import MatchingDetail from '../components/How-it-work/matching-details';
import FAQ from '../components/Global/faqs';
import FinalCTA from '../components/How-it-work/final-cta';

export default function Works() {
  return (
    <main>
      <div className="pt-20">
        <HowItWorksHero />
        <LeadTimeline />
        <VerificationDetail/>
        <MatchingDetail/>
        <FAQ/>
        <FinalCTA/>
      </div>
    </main>
  );
}
